/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MapActionsContext } from '../../common/map/BaseMapContainer';
import OrbitPathsContainer from './OrbitPathsContainer';
import { cancelRequestTerminalsPoll, getTerminals } from '../../../store/terminals/actions';

export interface TransportMonitoringMapProps {
  map: google.maps.Map;
}
const TransportMonitoringMap = ({ map }: TransportMonitoringMapProps) => {
  // 3rd Party Hooks
  const dispatch = useDispatch();

  // Context
  const mapActionsContext = useContext(MapActionsContext);
  const { setMapHidden } = mapActionsContext.mapActions;

  useEffect(() => {
    dispatch(getTerminals());

    return () => {
      dispatch(cancelRequestTerminalsPoll());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(setMapHidden(false));

    return () => {
      dispatch(setMapHidden(true));
    };
  }, [dispatch, setMapHidden]);

  return (
    <>
      <OrbitPathsContainer map={map} />
    </>
  );
};

export default TransportMonitoringMap;
